import type { ImmutableMap } from "@suse-o11y/immutable-map";
import type { Signal } from "@suse-o11y/signal";
import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

type QueryScopeContextValue = Signal<ImmutableMap<string, Signal<number>>>;

const QueryScopeContext = createContext<QueryScopeContextValue | undefined>(undefined);

const QueryScopeContextProvider = QueryScopeContext.Provider;

function useQueryScopeContext() {
	return useRequiredContext(QueryScopeContext, {
		providerName: "QueryScopeContext",
	});
}

export { QueryScopeContextProvider, useQueryScopeContext };
